<template>
  <div
    v-if="show"
    class="modal fade show d-block custom-backdrop"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content px-3 py-4">

        <!-- HEADER -->
        <div class="modal-header border-0 position-relative pb-2">

        <div class="text-center w-100">
            <i class="bi bi-person-circle login-icon"></i>
            <h4 class="mt-0 mb-0">{{ formTitle }}</h4>
        </div>

        <!-- CLOSE BUTTON -->
        <button
            type="button"
            class="btn-close position-absolute top-0 end-0"
            aria-label="Close"
            @click="closeModal"
        ></button>

        </div>

        <!-- =========================
             LOGIN FORM
        ========================== -->
        <form
            v-if="currentForm === 'login'"
            @submit.prevent="handleLogin"
            >
            <!-- EMAIL -->
            <div class="mb-3 input-group">
                <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-envelope-fill text-muted"></i>
                </span>

                <input
                v-model="email"
                type="email"
                class="form-control border-start-0 no-radius"
                placeholder="Email"
                required
                />
            </div>

            <!-- PASSWORD -->
            <div class="mb-3 input-group">
                <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-lock-fill text-muted"></i>
                </span>

                <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control border-start-0"
                placeholder="Password"
                required
                />

                <button
                type="button"
                class="btn btn-outline-secondary password-toggle"
                @click="toggleShowPassword"
                :aria-label="showPassword ? 'Hide password' : 'Show password'"
                >
                <i
                    :class="showPassword ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"
                ></i>
                </button>
            </div>

            <!-- REMEMBER / FORGOT -->
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="form-check">
                <input
                    id="rememberMe"
                    v-model="rememberMe"
                    class="form-check-input"
                    type="checkbox"
                />

                <label
                    class="form-check-label"
                    for="rememberMe"
                >
                    Remember me
                </label>
                </div>

                <a
                href="#"
                class="small primarylinks"
                @click.prevent="currentForm = 'reset'"
                >
                Forgot Password?
                </a>
            </div>

            <!-- LOGIN -->
            <button
                type="submit"
                class="btn loginuserbtn w-100"
            >
                Login
            </button>

            <!-- ERROR -->
            <div
                v-if="error"
                class="alert alert-danger mt-3 py-2 text-center"
            >
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                {{ error }}
            </div>

            <!-- SUCCESS -->
            <div
                v-if="success"
                class="alert alert-success mt-3 py-2 text-center"
            >
                <i class="bi bi-check-circle-fill me-2"></i>
                {{ success }}
            </div>

            <!-- REGISTER -->
            <div class="text-center mt-2">
                <span class="text-muted">
                Don't have an account?
                </span>

                <a
                href="#"
                class="primarylinks"
                @click.prevent="switchForm('register')"
                >
                Create one
                </a>
            </div>

            <!-- SOCIAL LOGIN -->
            <div class="d-flex gap-3 justify-content-center mt-3 mb-3">
                <button
                type="button"
                class="btn btn-outline-danger w-100"
                @click="handleGoogleLogin"
                >
                <i class="bi bi-google me-2"></i>
                Google
                </button>

                <button
                type="button"
                class="btn btn-outline-primary w-100"
                @click="handleMetaLogin"
                >
                <i class="bi bi-facebook me-2"></i>
                Facebook
                </button>
            </div>
            </form>

        <!-- =========================
             REGISTER FORM
        ========================== -->
        <form
            v-if="currentForm === 'register'"
            @submit.prevent="handleRegister"
            >
            <!-- EMAIL -->
            <div class="mb-3 input-group">
                <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-envelope-fill text-muted"></i>
                </span>

                <input
                v-model="email"
                type="email"
                class="form-control border-start-0 no-radius"
                placeholder="Email"
                required
                />
            </div>

            <!-- FIRST NAME -->
            <div class="mb-3 input-group">
                <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-person-fill text-muted"></i>
                </span>

                <input
                v-model="firstname"
                type="text"
                class="form-control border-start-0 no-radius"
                placeholder="First Name"
                required
                />
            </div>

            <!-- LAST NAME -->
            <div class="mb-3 input-group">
                <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-person-fill text-muted"></i>
                </span>

                <input
                v-model="lastname"
                type="text"
                class="form-control border-start-0 no-radius"
                placeholder="Last Name"
                required
                />
            </div>

            <!-- PASSWORD -->
            <div class="mb-3 input-group">
                <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-lock-fill text-muted"></i>
                </span>

                <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control border-start-0"
                placeholder="Password"
                required
                />

                <button
                type="button"
                class="btn btn-outline-secondary password-toggle"
                @click="toggleShowPassword"
                :aria-label="showPassword ? 'Hide password' : 'Show password'"
                >
                <i
                    :class="
                    showPassword
                        ? 'bi bi-eye-slash-fill'
                        : 'bi bi-eye-fill'
                    "
                ></i>
                </button>
            </div>

            <!-- REGISTER BUTTON -->
            <button
                type="submit"
                class="btn loginuserbtn w-100"
            >
                Register
            </button>

            <!-- ERROR -->
            <div
                v-if="error"
                class="alert alert-danger mt-3 py-2 text-center"
            >
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                {{ error }}
            </div>

            <!-- SUCCESS -->
            <div
                v-if="success"
                class="alert alert-success mt-3 py-2 text-center"
            >
                <i class="bi bi-check-circle-fill me-2"></i>
                {{ success }}
            </div>

            <!-- LOGIN LINK -->
            <div class="text-center mt-2">
                <span class="text-muted">
                Already have an account?
                </span>

                <a
                href="#"
                class="primarylinks"
                @click.prevent="switchForm('login')"
                >
                Back to Login
                </a>
            </div>
            </form>

        <!-- =========================
             RESET PASSWORD FORM
        ========================== -->
        <form
          v-if="currentForm === 'reset'"
          @submit.prevent="handleReset"
        >
          <div class="mb-3">
            <input
              v-model="email"
              type="email"
              class="form-control"
              placeholder="Enter your email"
              required
            />
          </div>

          <button
            type="submit"
            class="btn loginuserbtn w-100"
          >
            Reset Password
          </button>

          <!-- ERROR -->
          <div
            v-if="error"
            class="alert alert-danger mt-3 py-2 text-center"
          >
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ error }}
          </div>

          <!-- SUCCESS -->
          <div
            v-if="success"
            class="alert alert-success mt-3 py-2 text-center"
          >
            <i class="bi bi-check-circle-fill me-2"></i>
            {{ success }}
          </div>

          <div class="text-center mt-2">
            <a
              href="#"
              class="primarylinks"
              @click.prevent="switchForm('login')"
            >
              Back to Login
            </a>
          </div>
        </form>

        <!-- =========================
             OTP LOGIN FORM
        ========================== -->
        <form
          v-if="currentForm === 'otplogin'"
          @submit.prevent="handleOTPLogin"
        >
          <div class="mb-3 input-group">
            <span class="input-group-text bg-white border-end-0">
              <i class="bi bi-envelope-fill text-muted"></i>
            </span>

            <input
              v-model="email"
              type="email"
              class="form-control border-start-0 no-radius"
              placeholder="Email"
              required
            />
          </div>

          <div class="mb-3 input-group">
            <span class="input-group-text bg-white border-end-0">
              <i class="bi bi-lock-fill text-muted"></i>
            </span>

            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              class="form-control border-start-0 no-radius"
              placeholder="OTP"
              required
            />

            <button
              type="button"
              class="btn btn-outline-secondary border-start-0"
              @click="toggleShowPassword"
            >
              <i
                :class="
                  showPassword
                    ? 'bi bi-eye-slash-fill'
                    : 'bi bi-eye-fill'
                "
              ></i>
            </button>
          </div>

          <div class="d-flex justify-content-end align-items-center mb-3">
            <a
              href="#"
              class="small primarylinks"
              @click.prevent="switchForm('login')"
            >
              Back to Login
            </a>
          </div>

          <button
            type="submit"
            class="btn loginuserbtn w-100"
          >
            Login
          </button>

          <!-- ERROR -->
          <div
            v-if="error"
            class="alert alert-danger mt-3 py-2 text-center"
          >
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            {{ error }}
          </div>

          <!-- SUCCESS -->
          <div
            v-if="success"
            class="alert alert-success mt-3 py-2 text-center"
          >
            <i class="bi bi-check-circle-fill me-2"></i>
            {{ success }}
          </div>
        </form>

      </div>
    </div>
  </div>
</template>


<script>
import Config from '../Helpers/Config'

export default {

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'login',
    'toast',
    'close'
  ],

  data() {
    return {
      API_BASE_URL: Config.API_BASE_URL,

      email: '',
      password: '',
      firstname: '',
      lastname: '',

      rememberMe: false,

      error: '',
      success: '',

      showPassword: false,

      currentForm: 'login'
    }
  },

  computed: {

    formTitle() {
      switch (this.currentForm) {

        case 'login':
          return 'Login'

        case 'register':
          return 'Create Account'

        case 'reset':
          return 'Reset Password'

        case 'otplogin':
          return 'OTP Login'

        default:
          return 'Login'
      }
    }
  },

  methods: {

    // ==========================================
    // SWITCH FORM
    // ==========================================
    switchForm(form) {
      this.error = ''
      this.success = ''
      this.currentForm = form
    },

    // ==========================================
    // RESET FORM
    // ==========================================
    resetForm() {
      this.email = ''
      this.password = ''
      this.firstname = ''
      this.lastname = ''

      this.rememberMe = false
      this.showPassword = false

      this.error = ''
      this.success = ''
    },

    // ==========================================
    // TOGGLE PASSWORD
    // ==========================================
    toggleShowPassword() {
      this.showPassword = !this.showPassword
    },

    // ==========================================
    // CLOSE MODAL
    // ==========================================
    closeModal() {
      this.$emit('close')
    },

    // ==========================================
    // LOGIN
    // ==========================================
    async handleLogin() {

      if (!this.email || !this.password) {
        this.error = 'Please fill in all fields'
        return
      }

      this.error = ''
      this.success = ''

      try {

        const response = await fetch(
          `${this.API_BASE_URL}/login`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              email: this.email.trim(),
              password: this.password,
              rememberMe: this.rememberMe
            })
          }
        )

        const result = await response.json()

        if (result.success == '0') {
          this.error =
            result.errorDesc ||
            'Invalid email or password.'

          return
        }

        if (!response.ok) {
          throw new Error(
            result.errorDesc ||
            'Login failed'
          )
        }

        if (result.token) {

          localStorage.setItem(
            'auth_token',
            result.token
          )

          localStorage.setItem(
            'user_data',
            JSON.stringify(result.user)
          )

          this.$emit('login', result)

          this.$emit('toast', {
            message: 'Login successful!',
            type: 'success'
          })

          this.resetForm()
        }

      } catch (err) {

        console.error(err)

        this.error =
          err.message ||
          'Unexpected error occurred'
      }
    },

    // ==========================================
    // OTP LOGIN
    // ==========================================
    async handleOTPLogin() {

      if (!this.email || !this.password) {
        this.error = 'Please fill in all fields'
        return
      }

      this.error = ''
      this.success = ''

      try {

        const response = await fetch(
          `${this.API_BASE_URL}/confirm_otp`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              email: this.email.trim(),
              auth_otp: this.password.trim(),
              rememberMe: this.rememberMe
            })
          }
        )

        const result = await response.json()

        if (result.success == '0') {
          this.error =
            result.errorDesc ||
            'Invalid OTP.'

          return
        }

        if (!response.ok) {
          throw new Error(
            result.errorDesc ||
            'OTP login failed'
          )
        }

        if (result.token) {

          localStorage.setItem(
            'auth_token',
            result.token
          )

          localStorage.setItem(
            'user_data',
            JSON.stringify(result.user)
          )

          this.$emit('login', result)

          this.$emit('toast', {
            message: 'Login successful!',
            type: 'success'
          })

          this.resetForm()
        }

      } catch (err) {

        console.error(err)

        this.error =
          err.message ||
          'Unexpected error occurred'
      }
    },

    // ==========================================
    // REGISTER
    // ==========================================
    async handleRegister() {

      if (
        !this.email ||
        !this.password ||
        !this.firstname ||
        !this.lastname
      ) {
        this.error = 'Please fill in all fields'
        return
      }

      this.error = ''
      this.success = ''

      try {

        const response = await fetch(
          `${this.API_BASE_URL}/sign_up`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              firstname: this.firstname.trim(),
              lastname: this.lastname.trim(),
              email: this.email.trim(),
              password: this.password
            })
          }
        )

        const result = await response.json()

        if (result.success == '0') {

          this.error =
            result.errorDesc ||
            'Registration failed'

          return
        }

        if (!response.ok) {

          throw new Error(
            result.errorDesc ||
            'Registration failed'
          )
        }

        if (result.success == '1') {

          // Keep email so user can login immediately
          const registeredEmail = this.email

          this.currentForm = 'login'

          this.password = ''
          this.firstname = ''
          this.lastname = ''

          this.email = registeredEmail

          this.success =
            'Registration successful! Please login.'
        }

      } catch (err) {

        console.error(err)

        this.error =
          err.message ||
          'Unexpected error occurred'
      }
    },

    // ==========================================
    // RESET PASSWORD
    // ==========================================
    async handleReset() {

      this.error = ''
      this.success = ''

      if (!this.email) {
        this.error = 'Please enter your email'
        return
      }

      try {

        const response = await fetch(
          `${this.API_BASE_URL}/resend_otp`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              email: this.email.trim()
            })
          }
        )

        const result = await response.json()

        if (
          !response.ok ||
          result.success === '0'
        ) {
          throw new Error(
            result.errorDesc ||
            'Reset failed'
          )
        }

        if (result.success == '1') {

          this.currentForm = 'otplogin'

          this.password = ''
          this.showPassword = false
          this.rememberMe = false

          this.success =
            'OTP sent successfully. Please enter the OTP.'
        }

      } catch (err) {

        console.error(err)

        this.error =
          err.message ||
          'Error occurred during reset'
      }
    },

    // ==========================================
    // GOOGLE LOGIN
    // ==========================================
    handleGoogleLogin() {

      console.log('Google login clicked')

      // Add Google authentication here
    },

    // ==========================================
    // FACEBOOK LOGIN
    // ==========================================
    handleMetaLogin() {

      console.log('Facebook login clicked')

      // Add Facebook authentication here
    }
  }
}
</script>


<style scoped>

.custom-backdrop {
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 4000;
}

.login-icon {
  font-size: 3rem;
  color: var(--primary-color);
}

.primarylinks {
  color: var(--primary-color);
}

.no-radius {
  border-radius: 0 !important;
  box-shadow: none !important;
}

.input-group-text {
  border-radius: 0;
}

button:focus {
  box-shadow: none !important;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal {
  z-index: 1050;
  animation: fadeIn 0.3s ease-out;
}

.loginuserbtn {
  background-color: var(--primary-color);
  color: #fff;
  border: none;
}

.loginuserbtn:hover {
  background-color: var(--primary-color);
  opacity: 0.8;
}

.form-control:focus,
.form-control:focus-visible,
.password-toggle:focus,
.password-toggle:focus-visible,
.input-group-text:focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: #dee2e6 !important;
}

</style>